<template>
  <div class="page-container">
    <div class="page-header">
      <h2>用户管理</h2>
    </div>

    <div class="filter-bar">
      <el-input
        v-model="filterForm.nickname"
        placeholder="用户昵称"
        size="small"
        style="width: 200px;"
      />
      <el-input
        v-model="filterForm.phone"
        placeholder="手机号"
        size="small"
        style="width: 200px; margin-left: 10px;"
      />
      <el-select v-model="filterForm.status" placeholder="状态" size="small" style="width: 120px; margin-left: 10px;">
        <el-option label="全部" :value="undefined" />
        <el-option label="正常" :value="1" />
        <el-option label="禁用" :value="0" />
      </el-select>
      <el-button type="primary" size="small" style="margin-left: 10px;" @click="loadData">查询</el-button>
      <el-button type="default" size="small" style="margin-left: 10px;" @click="handleReset">重置</el-button>
    </div>

    <el-table :data="list" v-loading="loading" border stripe>
      <el-table-column prop="id" label="ID" width="80" align="center" />
      <el-table-column prop="nickname" label="昵称" width="150" />
      <el-table-column prop="avatar" label="头像" width="80" align="center">
        <template slot-scope="scope">
          <el-avatar :size="40" :src="scope.row.avatar" v-if="scope.row.avatar">
            {{ scope.row.nickname?.charAt(0) || 'U' }}
          </el-avatar>
          <el-avatar :size="40" v-else>
            {{ scope.row.nickname?.charAt(0) || 'U' }}
          </el-avatar>
        </template>
      </el-table-column>
      <el-table-column prop="realName" label="真实姓名" width="120" />
      <el-table-column prop="phone" label="手机号" width="140" />
      <el-table-column prop="email" label="邮箱" width="180" />
      <el-table-column label="角色" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.role === 1 ? 'danger' : 'info'" size="small">
            {{ scope.row.role === 1 ? '管理员' : '普通用户' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'warning'" size="small">
            {{ scope.row.status === 1 ? '正常' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="注册时间" width="160" align="center" />
      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editRow(scope.row)">编辑</el-button>
          <el-button
            type="text"
            size="small"
            :style="scope.row.status === 1 ? 'color: #F56C6C;' : 'color: #67C23A;'"
            @click="toggleStatus(scope.row)"
          >{{ scope.row.status === 1 ? '禁用' : '启用' }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    />

    <!-- 编辑弹窗 -->
    <el-dialog title="编辑用户" :visible.sync="showDialog" width="500px">
      <el-form :model="form" label-width="80px">
        <el-form-item label="昵称">
          <el-input v-model="form.nickname" placeholder="请输入昵称" />
        </el-form-item>
        <el-form-item label="真实姓名">
          <el-input v-model="form.realName" placeholder="请输入真实姓名" />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="form.phone" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="form.email" placeholder="请输入邮箱" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showDialog = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUserList, updateUser, updateUserStatus } from '@/api/user'

export default {
  name: 'UserList',
  data() {
    return {
      filterForm: {
        nickname: '',
        phone: '',
        status: ''
      },
      list: [],
      page: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      showDialog: false,
      saving: false,
      form: {
        id: null,
        nickname: '',
        realName: '',
        phone: '',
        email: ''
      }
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const res = await getUserList({
          page: this.page,
          pageSize: this.pageSize,
          nickname: this.filterForm.nickname || undefined,
          phone: this.filterForm.phone || undefined,
          status: this.filterForm.status
        })
        this.list = res.data?.records || res.data?.list || []
        this.total = res.data?.total || 0
      } catch (e) {
        this.$message.error('加载失败')
      } finally {
        this.loading = false
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.loadData()
    },
    handleReset() {
      this.filterForm = {
        nickname: '',
        phone: '',
        status: ''
      }
      this.loadData()
    },
    editRow(row) {
      this.form = {
        id: row.id,
        nickname: row.nickname,
        realName: row.realName,
        phone: row.phone,
        email: row.email
      }
      this.showDialog = true
    },
    async handleSave() {
      this.saving = true
      try {
        await updateUser(this.form.id, this.form)
        this.$message.success('保存成功')
        this.showDialog = false
        this.loadData()
      } catch (e) {
        this.$message.error(e.message || '保存失败')
      } finally {
        this.saving = false
      }
    },
    async toggleStatus(row) {
      try {
        const newStatus = row.status === 1 ? 0 : 1
        await updateUserStatus(row.id, newStatus)
        row.status = newStatus
        this.$message.success(newStatus === 1 ? '已启用' : '已禁用')
      } catch (e) {
        this.$message.error(e.message || '操作失败')
      }
    }
  }
}
</script>

<style scoped>
.page-container {
  padding: 20px;
}
.page-header {
  margin-bottom: 20px;
}
.page-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
}
.filter-bar {
  margin-bottom: 20px;
  padding: 15px 20px;
  background: #f8f9fa;
  border-radius: 8px;
}
</style>
